// Company updates, policy notes, subsidy alerts.
// Add newest entry at the TOP. Types: "update" | "policy" | "subsidy" | "release"
export const CHANGELOG = [
  {
    id: "2025-11-atmanirbhar-textile-etp",
    date: "2025-11-14",
    type: "subsidy",
    title: "Atmanirbhar Textile Policy — ETP subsidy of ₹70 L released",
    body:
      "Effluent Treatment Plant subsidy under the Atmanirbhar Textile Policy has been disbursed for Gayatri Overseas, Panipat. Applications for FY 2025–26 are open — capex-linked, 25% (up to ₹1 Cr) for ETP infrastructure.",
    tags: ["Haryana", "Textile", "ETP", "Disbursed"],
  },
  {
    id: "2025-10-padma-cluster",
    date: "2025-10-02",
    type: "policy",
    title: "PADMA Cluster Scheme — second-tranche disbursement",
    body:
      "₹12.5 Cr disbursed to Earth Industrial Park under the PADMA Cluster Infrastructure Development Scheme. Balance sanction of ₹22.5 Cr is under progressive-release milestones tied to civil-work completion.",
    tags: ["Haryana", "PADMA", "Industrial Park"],
  },
  {
    id: "2025-09-msefc-samadhaan",
    date: "2025-09-18",
    type: "update",
    title: "MSEFC filings — average settlement time down to 47 days",
    body:
      "Across 42 MSEFC cases filed via MSME Samadhaan portal this quarter, our average time to first hearing was 21 days and to settlement/award was 47 days. Statutory interest computation now templated for faster filing.",
    tags: ["Arbitration", "MSMED Act"],
  },
  {
    id: "2025-08-food-processing",
    date: "2025-08-05",
    type: "subsidy",
    title: "Food processing grant — ₹1.25 Cr received",
    body:
      "GM Foods Pvt. Ltd., Sonipat received a ₹1.25 Cr grant on a ₹2.5 Cr sanction for its spices and ready-to-cook manufacturing facility. Filing turnaround was 6 months from concept-note to disbursement.",
    tags: ["Sonipat", "Food Processing", "Grant"],
  },
  {
    id: "2025-07-launch",
    date: "2025-07-01",
    type: "release",
    title: "MSMEmoney.ai — public launch",
    body:
      "We are live. Backed by Sera One Pvt. Ltd. and recognized by DPIIT, Government of India. Three practices: government subsidies, MSME arbitration, and project funding. WhatsApp us any time.",
    tags: ["Company", "Launch"],
  },
];
